import "./feature-flag-schedule-commentary"
import { useParams } from "react-router"
import { authoringRoute } from "../../authoring.runtime"
import { withProjectBoundary } from "../project.runtime"
import { Secure } from "lib/authorization/secure"
import { Redirect } from "lib/@components/redirect"
import { AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { FEATURE_FLAG_SCHEDULE_COMMENTARY } from "authoring/lib/enum/authoring-feature-flags.mjs"
import { ScheduleCommentary } from "./schedule-commentary-page"

const ScheduleCommentaryWithBoundary = withProjectBoundary(ScheduleCommentary)
const scheduleCommentaryDemands = [
    "user",
    `$feature-${FEATURE_FLAG_SCHEDULE_COMMENTARY}`,
    AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND,
]

authoringRoute.register(
    "projects/:projectId/schedule-editor/:scheduleId/commentary",
    <ScheduleCommentaryGuard>
        <ScheduleCommentaryWithBoundary $lazy priority={50} />
    </ScheduleCommentaryGuard>
)

function ScheduleCommentaryGuard({ children }) {
    const { projectId, scheduleId } = useParams()

    return (
        <Secure
            demand={scheduleCommentaryDemands}
            and
            fallback={<Redirect to={`/authoring/projects/${projectId}/schedule-editor/${scheduleId}/preview`} />}
        >
            {children}
        </Secure>
    )
}
